// extracted by mini-css-extract-plugin
module.exports = {"panel":"CodeBlock_panel__tRXoL","preformattedText":"CodeBlock_preformattedText__Vb7r5","textBody":"CodeBlock_textBody__FMx59","line":"CodeBlock_line__LiSKI"};